

export interface BeforeStart {
    letterPack: string;
    // financialAdvise: string;
    // pensionGuidance: string;
    retirementOptions: string;
    riskAndStaticQuestion: any[];
}
